module.exports = "<app-page-container\n  [tipo_usuario]=\"'paciente'\"\n  [titulo]=\"'Caderneta da gestante'\">\n</app-page-container>\n"